/**
 * Language links for transcript - opens transcript page in new tab
 */

import { languageButtonsContainer, availableLanguages, currentLanguage } from './state.js';
import { extractLectureNameFromCurrentFile } from './lecture-utils.js';
import { getAudioPlayerElement } from '../player-core.js';

/**
 * Get language display name
 * @param {string} langCode - Language code
 * @returns {string}
 */
function getLanguageName(langCode) {
	const names = {
		'en': 'EN',
		'ru': 'RU',
		'de': 'DE'
	};
	return names[langCode] || langCode.toUpperCase();
}

/**
 * Build transcript URL for a lecture and language
 * @param {string} lectureName - Lecture name
 * @param {string} lang - Language code
 * @returns {string} - URL to transcript page
 */
function buildTranscriptUrl(lectureName, lang) {
	if (!lectureName) return null;
	// URL format: /lectures/?lect={lectureName}&tr_lng={lang}
	const encodedLecture = encodeURIComponent(lectureName);
	return `/lectures/?lect=${encodedLecture}&tr_lng=${lang}`;
}

/**
 * Render language links as "Study here" invitation
 * @param {string} lectureName - Lecture name (optional, will be extracted if not provided)
 */
export function renderLanguageButtons(lectureName = null) {
	if (!languageButtonsContainer || availableLanguages.length === 0) {
		if (languageButtonsContainer) {
			languageButtonsContainer.empty();
		}
		return;
	}
	
	// If lectureName not provided, try to extract from current file
	if (!lectureName) {
		lectureName = extractLectureNameFromCurrentFile();
	}
	
	if (!lectureName) {
		if (languageButtonsContainer) {
			languageButtonsContainer.empty();
		}
		return;
	}
	
	// Build HTML with "Study in sync" text and language links
	let html = '<div class="transcript-languages">';
	html += '<span class="transcript-study-invitation">Study in sync (audio + text):</span> ';
	
	availableLanguages.forEach((lang, index) => {
		const langName = getLanguageName(lang);
		const url = buildTranscriptUrl(lectureName, lang);
		if (url) {
			if (index > 0) {
				html += ' ';
			}
			html += `<a href="${url}" target="_blank" class="transcript-lang-link" data-lang="${lang}" aria-label="Study ${langName} transcript">${langName}</a>`;
		}
	});
	
	html += '</div>';
	
	languageButtonsContainer.html(html);
	
	// Stop audio player on transcript language link click
	languageButtonsContainer.find('.transcript-lang-link').on('click', function(e) {
		const audioPlayerElement = getAudioPlayerElement();
		if (audioPlayerElement && audioPlayerElement.length) {
			const audio = audioPlayerElement.find('audio');
			if (audio.length > 0 && audio[0]) {
				const audioEl = audio[0];
				if (!audioEl.paused) {
					audioEl.pause();
					audioEl.currentTime = 0;
				}
			}
		}
	});
}

